












































import { Component, Vue } from 'vue-property-decorator';
import { MDAConstant } from '@/libs/com/MetaPattern/MDA/Designer/Base/MDAConstant';
import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
import { DesignerExtendService } from '@/libs/com/MetaPattern/MDA/Designer/DesignerExtendService';
import { Diagram } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Diagram';

@Component({
  components: {}
})
export default class DrawTypeScope extends Vue {
  activeNames: string[] = ['1', '2'];
  linkType = '';
  action = MDAConstant;

  pick(e: any, shape: string) {
    // console.log('draw start :' + shape);
    // console.log(e.target.x + shape);
    e.dataTransfer.setData('type', shape);
  }

  created() {
    EventBus.$on('endAddLink', () => {
      this.$store.dispatch('ModuleMD/setCurLinkTypeAction', '');
      this.linkType = '';
    });
  }

  beforeDestroy() {
    EventBus.$off('endAddLink');
  }

  selectLink(link: string) {
    this.linkType = link;
    this.$store.dispatch('ModuleMD/setCurLinkTypeAction', link);
  }

  getLinkStyle(type: string): string {
    if (type === this.linkType) {
      return 'border:1px solid #909399';
    }
    return 'border:1px solid #ffffff';
  }

  isAllow(shapeType: string): boolean {
    let result = false;
    const diagram = this.$store.state.ModuleMD.curDiagram as Diagram;
    if (diagram && diagram !== null && diagram.component !== null) {
      result = DesignerExtendService.checkShapeAllowed(diagram.component.componentType, shapeType);
    }
    return result;
  }

  // 是否有类型
  hasType(): boolean {
    return this.isAllow(MDAConstant.Type.ADD_PRODUCTCOMMENT) ||
      this.isAllow(MDAConstant.Type.ADD_PRODUCTAPP) ||
      this.isAllow(MDAConstant.Type.ADD_APPCOMMENT) ||
      this.isAllow(MDAConstant.Type.ADD_BECOMMENT) ||
      this.isAllow(MDAConstant.Type.ADD_INTERFACE) ||
      this.isAllow(MDAConstant.Type.ADD_CONFIGGROUP) ||
      this.isAllow(MDAConstant.Type.ADD_DISTRIBUTEDTRANSACTION) ||
      this.isAllow(MDAConstant.Type.ADD_EXTERNALSERVICE) ||
      this.isAllow(MDAConstant.Type.ADD_ENTITY) ||
      this.isAllow(MDAConstant.Type.ADD_ENUM) ||
      this.isAllow(MDAConstant.Type.ADD_BUSINESSLOGIC) ||
      this.isAllow(MDAConstant.Type.ADD_DTO) ||
      this.isAllow(MDAConstant.Type.ADD_VALUEOBJECT) ||
      this.isAllow(MDAConstant.Type.ADD_SERVICE) ||
      this.isAllow(MDAConstant.Type.ADD_REFERENCEENTITY) ||
      this.isAllow(MDAConstant.Type.ADD_CONSTANT) ||
      this.isAllow(MDAConstant.Type.ADD_MENUSET);
  }

  // 是否有关系
  hasLink(): boolean {
    return this.isAllow(MDAConstant.Link.ADD_ASSOCIATION) ||
      this.isAllow(MDAConstant.Link.ADD_IMPLEMENT) ||
      this.isAllow(MDAConstant.Link.ADD_GENERALIZATION) ||
      this.isAllow(MDAConstant.Link.ADD_DEPENDENCY) ||
      this.isAllow(MDAConstant.Link.ADD_COMPOSITION) ||
      this.isAllow(MDAConstant.Link.ADD_AGGREGATION) ||
      this.isAllow(MDAConstant.Link.ADD_CROSS) ||
      this.isAllow(MDAConstant.Link.ADD_MENUCONTAIN);
  }

  /**
   * 获取类型图标
   * @param typeName 类型名称，使用MDAConstant
   */
  getTypeIcon(typeName: string) {
    return DesignerExtendService.getTypeIcon(typeName);
  }
}
